var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import semver from 'semver';
import { useRef } from 'react';
import { symbolToken } from '@servicetitan/react-ioc';
export const BASENAME_TOKEN = symbolToken('BASENAME_TOKEN');
export const EXPOSED_DEPENDENCIES_TOKEN = symbolToken('EXPOSED_DEPENDENCIES_TOKEN');
export const IS_WEB_COMPONENT_TOKEN = symbolToken('IS_WEB_COMPONENT_TOKEN');
export const RENDER_ROOT_TOKEN = symbolToken('RENDER_ROOT_TOKEN');
export function isCompatible(hostVersion, packageVersion) {
    if (hostVersion === packageVersion) {
        return true;
    }
    if (hostVersion === '*') {
        return false;
    }
    if (packageVersion === '*') {
        return true;
    }
    // host and package have exact non-equal versions
    if (semver.valid(hostVersion) && semver.valid(packageVersion)) {
        return false;
    }
    // exact package version couldn't be compatible with host range
    if (semver.validRange(hostVersion) && semver.valid(packageVersion)) {
        return false;
    }
    // exact host version must be in package range
    if (semver.valid(hostVersion) && semver.validRange(packageVersion)) {
        return semver.satisfies(hostVersion, packageVersion);
    }
    // host range must be fully included in package range
    if (semver.validRange(hostVersion) && semver.validRange(packageVersion)) {
        return semver.subset(hostVersion, packageVersion);
    }
    return false;
}
export function getJson(url_1) {
    return __awaiter(this, arguments, void 0, function* (url, _a = {}) {
        var _b, _c;
        var { retries = 5, retryDelay = 1000, onRequestError } = _a, config = __rest(_a, ["retries", "retryDelay", "onRequestError"]);
        let response;
        try {
            response = yield fetch(url, config);
        }
        catch (_d) {
            if (retries > 0 && !((_b = config.signal) === null || _b === void 0 ? void 0 : _b.aborted)) {
                return new Promise((resolve, reject) => {
                    const { signal } = config;
                    const timeoutId = window.setTimeout(() => {
                        getJson(url, Object.assign(Object.assign({}, config), { onRequestError, retries: retries - 1, retryDelay: retryDelay * 4 })).then(resolve, reject);
                    }, retryDelay);
                    const abortHandler = () => {
                        window.clearTimeout(timeoutId);
                        signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abortHandler);
                        reject(signal === null || signal === void 0 ? void 0 : signal.reason);
                    };
                    signal === null || signal === void 0 ? void 0 : signal.addEventListener('abort', abortHandler);
                });
            }
            throw new Error(`Failed to fetch: "${url}".`);
        }
        const responseJSON = yield response.json().catch(() => ({}));
        if (!response.ok) {
            let message = `Requesting "${url}" failed with status code ${response.status}.`;
            try {
                message += ` Details: ${yield response.text()}.`;
            }
            catch (_e) { } // eslint-disable-line no-empty
            onRequestError === null || onRequestError === void 0 ? void 0 : onRequestError({
                status: response.status,
                json: responseJSON,
                body: yield response.text().catch(() => ''),
            });
            throw new Error(message);
        }
        return { data: responseJSON, headers: response.headers, url: (_c = response.url) !== null && _c !== void 0 ? _c : url };
    });
}
export function useCancelation() {
    return useRef(new AbortController()).current;
}
//# sourceMappingURL=common.js.map